export const types = {
  FETCH_EPG_LIST: "[EPG] Fetch Epg List",
  FETCH_EPG_LIST_SUCCESS: "[EPG] Fetch Epg Success",
  FETCH_EPG_LIST_FAILED: "[EPG] Fetch Epg Failed",
  FETCH_MORE_EPG_LIST: "[EPG] Fetch More Epg List",
  FETCH_MORE_EPG_LIST_SUCCESS: "[EPG] Fetch More Epg Success",
  FETCH_MORE_EPG_LIST_FAILED: "[EPG] Fetch More Epg Failed",
  UPDATE_EPG_LIST_ITEM: "[EPG] Update Epg List Item",
  UPDATE_EPG_LIST_ITEM_SUCCESS: "[EPG] Update Epg List item Success",
  UPDATE_EPG_LIST_ITEM_FAILED: "[EPG] Update Epg List item Failed",
  EPG_CHANNEL_ADD: "[EPG] Epg Channel Add",
  EPG_CHANNEL_ADD_SUCCESS: "[EPG] Epg Channel Add Success",
  EPG_CHANNEL_ADD_FAILED: "[EPG] Epg Channel Add Failed",
  DELETE_EPG_CHANNEL: "[EPG] Epg Delete Epg Channel",
  DELETE_EPG_CHANNEL_SUCCESS: "[EPG] Epg Delete Epg Channel Success",
  DELETE_EPG_CHANNEL_FAILED: "[EPG] Epg Delete Epg Channel Failed",
  CLEAR_RESPONSES: "[EPG] Epg Clear Responses",
  FETCH_EPG_CHANNEL_CHANGE_LOG: "[EPG] Fetch Epg Channel CHange Log",
  FETCH_EPG_CHANNEL_CHANGE_LOG_SUCCESS:
    "[EPG] Fetch Epg Channel CHange Log Success",
  FETCH_EPG_CHANNEL_CHANGE_LOG_FAILED:
    "[EPG] Fetch Epg Channel CHange Log Failed",
};

export const FetchEpgList = (payload) => ({
  type: types.FETCH_EPG_LIST,
  payload: payload,
});

export const FetchEpgListSuccess = (list) => ({
  type: types.FETCH_EPG_LIST_SUCCESS,
  payload: list,
});
export const FetchEpgListFailed = (error) => ({
  type: types.FETCH_EPG_LIST_FAILED,
  payload: error,
});
export const updateEpgListItem = (payload) => ({
  type: types.UPDATE_EPG_LIST_ITEM,
  payload: payload,
});

export const updateEpgListItemSuccess = (list) => ({
  type: types.UPDATE_EPG_LIST_ITEM_SUCCESS,
  payload: list,
});
export const updateEpgListItemFailed = (error) => ({
  type: types.UPDATE_EPG_LIST_ITEM_FAILED,
  payload: error,
});
export const addEpgChannel = (payload) => ({
  type: types.EPG_CHANNEL_ADD,
  payload: payload,
});

export const addEpgChannelAddSuccess = (list) => ({
  type: types.EPG_CHANNEL_ADD_SUCCESS,
  payload: list,
});
export const addEpgChannelAddFailed = (error) => ({
  type: types.EPG_CHANNEL_ADD_FAILED,
  payload: error,
});
export const FetchMoreEpgList = (payload) => ({
  type: types.FETCH_MORE_EPG_LIST,
  payload: payload,
});

export const FetchMoreEpgListSuccess = (list) => ({
  type: types.FETCH_MORE_EPG_LIST_SUCCESS,
  payload: list,
});
export const FetchMoreEpgListFailed = (error) => ({
  type: types.FETCH_MORE_EPG_LIST_FAILED,
  payload: error,
});
export const DeleteEpgChannel = (id) => ({
  type: types.DELETE_EPG_CHANNEL,
  payload: id,
});

export const DeleteEpgChannelSuccess = (list) => ({
  type: types.DELETE_EPG_CHANNEL_SUCCESS,
  payload: list,
});
export const DeleteEpgChannelFailed = (error) => ({
  type: types.DELETE_EPG_CHANNEL_FAILED,
  payload: error,
});
export const clearResponses = () => ({
  type: types.CLEAR_RESPONSES,
});
export const FetchEpgChangeLog = () => ({
  type: types.FETCH_EPG_CHANNEL_CHANGE_LOG,
});

export const FetchEpgChangeLogSuccess = (list) => ({
  type: types.FETCH_EPG_CHANNEL_CHANGE_LOG_SUCCESS,
  payload: list,
});
export const FetchEpgChangeLogFailed = (error) => ({
  type: types.FETCH_EPG_CHANNEL_CHANGE_LOG_FAILED,
  payload: error,
});
